var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "mask",
      class: { "mask-hidden": _vm.isSubDialogOpen },
      on: {
        mousedown: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClose.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isSubDialogOpen,
              expression: "!isSubDialogOpen",
            },
          ],
          staticClass: "edit-dialog",
        },
        [
          _c("div", { staticClass: "edit-header" }, [
            _c("span", { staticClass: "edit-header-title" }, [
              _vm._v(_vm._s(_vm.$t("homePage.novelList.grouping.editTitle"))),
            ]),
            _c(
              "button",
              { staticClass: "edit-close-button", on: { click: _vm.onClose } },
              [_c("IconClose", { staticClass: "edit-close-icon" })],
              1
            ),
          ]),
          _vm.groups.length === 0
            ? [
                _c("div", { staticClass: "edit-empty" }, [
                  _c("p", { staticClass: "edit-empty-message" }, [
                    _vm._v(
                      _vm._s(_vm.$t("homePage.novelList.grouping.emptyMessage"))
                    ),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "edit-create-button",
                      on: { click: _vm.onClickCreateGroup },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("homePage.novelList.grouping.createNew")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "edit-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "edit-cancel-button",
                      on: { click: _vm.onClose },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.close")) + " ")]
                  ),
                ]),
              ]
            : [
                _c(
                  "div",
                  { staticClass: "edit-search" },
                  [
                    _c("IconSearch", { staticClass: "edit-search-icon" }),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchQuery,
                          expression: "searchQuery",
                        },
                      ],
                      staticClass: "edit-search-input",
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t(
                          "homePage.novelList.grouping.searchPlaceholder"
                        ),
                      },
                      domProps: { value: _vm.searchQuery },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.searchQuery = $event.target.value
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "edit-body" },
                  [
                    _c("SortableList", {
                      attrs: {
                        items: _vm.filteredGroups,
                        disabled: _vm.isSaving || !!_vm.searchQuery,
                        keyAttr: "groupId",
                        handleClassName: ".drag-handle",
                        onReorder: _vm.onReorder,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ item, index }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "edit-group-row",
                                  class: {
                                    "edit-group-row-alt": index % 2 === 1,
                                    "edit-group-row-disabled": _vm.isSaving,
                                  },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "edit-drag-handle drag-handle",
                                      attrs: {
                                        disabled:
                                          _vm.isSaving || !!_vm.searchQuery,
                                        "aria-label": _vm.$t(
                                          "homePage.novelList.grouping.reorderHandleLabel"
                                        ),
                                      },
                                    },
                                    [
                                      _c("IconHandle", {
                                        staticClass: "edit-icon",
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "edit-group-name" },
                                    [_vm._v(_vm._s(item.name))]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "edit-group-actions" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "edit-icon-button",
                                          attrs: { disabled: _vm.isSaving },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onClickRename(item)
                                            },
                                          },
                                        },
                                        [
                                          _c("IconPencil", {
                                            staticClass: "edit-icon",
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "edit-icon-button edit-icon-danger",
                                          attrs: { disabled: _vm.isSaving },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onClickDelete(item)
                                            },
                                          },
                                        },
                                        [
                                          _c("IconTrash", {
                                            staticClass: "edit-icon",
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "edit-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "edit-cancel-button",
                      on: { click: _vm.onClose },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.close")) + " ")]
                  ),
                ]),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }